import Dialog from "../../atoms/dialog";
import { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Button, Box, Typography, Divider } from '@material-ui/core';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";

const CodeSaveAlert = (props) => {
    const { onClose, onSave } = props;
    const [open, setOpen] = useState(false)
    const [isSaving, setIsSaving] = useState(false);

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    const onUpdate = () => {
        setIsSaving(true);
        onSave();
    }

    return (

        <Dialog
            title={"Unsaved Code Detected"}
            open={true}
            handleClose={handleClose}
            paperProps={{ id: "unsavedCodeAlert" }}
        >
            <Grid container direction={"row"} spacing={1} >
                <Fragment>
                    <Typography> Do you want to save the changes made to this code before closing?</Typography>
                </Fragment>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <UpdateCancel onUpdate={onUpdate} onCancel={onClose} content={isSaving ? 'Saving..' : 'Save'} />
                </Grid>
            </Grid>

        </Dialog >
    )

}

export default CodeSaveAlert;